export enum MasterPlanTypes {
    LDPlanning = 1,
    HDPlanning = 2,
  }
